import gql from 'graphql-tag'

export default gql`query getPartner ($id: Int!) {
	getPartner(id: $id) {
		id
		name
		logo
		url
	}
}
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/partner/get.js